// extracted by mini-css-extract-plugin
module.exports = {"container":"Video_container__Iqj1L","heading":"Video_heading__7rvTb","sec_text":"Video_sec_text__anQUr","videos_container":"Video_videos_container__rxMzS"};